// extracted by mini-css-extract-plugin
export default {"vertical-dots":"styles_vertical-dots__lgg3N","option-icon":"styles_option-icon__wdakn"};